<template>
  <div class="text-right">
    <v-dialog v-model="dialog" width="750">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="grey darken-1" size="30">mdi-help-circle</v-icon>
        </v-btn>
      </template>

      <v-card color="grey lighten-5">
        <v-card-title
          class="text-h5 primary white--text"
          v-text="`O que é a renda per capita?`"
        />

        <v-card-text class="pt-3">
          A chamada <strong>renda familiar per capita</strong> é feita com base
          no cálculo que envolve a soma da renda de todos os moradores de uma
          residência, e que é dividida pelo número total de pessoas que vivem
          sob a manutenção desta renda total.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
